import React, { useState, useEffect, useLayoutEffect, useRef } from 'react';
import FilterBar from '../../../components/FilterBar';
import { useDispatch, useSelector } from 'react-redux';
import { Col, ConfigProvider, Row, Select, Spin, Tabs, DatePicker } from 'antd';
import { IoArrowBack } from 'react-icons/io5';
import { convertToPdf } from '../../../config/util/pdfConverter';
import { useNavigate } from 'react-router-dom';
import BasicDrawer from '../../../components/Drawer';
import BasicText from '../../../components/Text/BasicText';
import { Colors } from '../../../config';
import AssignShiftDrawer from './assignShiftDrawer';
import filter from '../../../assets/images/filter.png';
import { Button, Pagination } from '../../../components';
import App from './App';
import moment from 'moment';
import { ShiftSchedulerAction, UserManagementAction } from '../../../store/actions';
import UserDetailDrawer from '../../UserManagement/UserDetailDrawer';
import { PlusOutlined, PrinterOutlined } from '@ant-design/icons';
import { useQuery } from 'react-query';
import {
    getAllProperties,
    getAllUsers,
    getEligibiity,
    getSchedules,
    getLocationsByProperty,
} from '../../../config/getApis';
import avatar from '../../../assets/images/avatar.jpg';
import DetailShiftDrawer from './detailShiftDrawer';
import UserPublicationDrawer from './userPublicationDrawer';
import useColors from '../../../hooks/useColors';
import { FaFilter } from 'react-icons/fa6';
import currentDate from '../../../config/util/index';
import { ViewType } from './react-big-schedule';
import dayjs from 'dayjs';
import LoadOnScroll from '../../../components/LoadOnScroll';
import util from '../../../config/util/index.js';

const formatAddress = (address) => {
    if (!address) return '';
    const { streetNumber, streetName, city, buildingNumber } = address;
    const parts = [streetNumber, streetName, city, buildingNumber].filter(
        (part) =>
            part !== null &&
            part !== undefined &&
            part !== 'undefined' &&
            String(part).trim() !== '',
    );
    return parts.length > 0 ? parts.join(',') : '';
};

const ShiftScheduler = () => {
    const { colorPrimary } = useColors();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const scrollContainerRef = useRef(null);
    const printRef = useRef(null);
    // Tracks the date currently selected inside CustomCalendar for Day-view printing
    const [printSelectedDate, setPrintSelectedDate] = useState(new Date());

    const { user } = useSelector((state) => state?.AppReducer);
    const userRole = user?.userRole[0];

    // NOTE: the reducer's `loader` belongs to the GET_SHIFTS saga, which this screen
    // no longer uses (LoadOnScroll does the fetching), so it is intentionally not read.
    const { shiftsData } = useSelector(
        (state) => state?.ShiftSchedulerReducer,
    );
    const { data: shiftRecords, paginate } = shiftsData;
    console.log('shifts records data', shiftRecords);

    const [state, setState] = useState({
        limit: 100,
        page: 1,
        tabKey: 0,
        filterDrawer: {
            schedule: '',
            user: '',
            eligiblity: '',
            jobSite: '',
            location: '',
            shiftDate: '',
        },
    });

    const [openShiftDetail, setOpenShiftDetail] = useState(null);
    console.log(openShiftDetail, 'openShiftDetail');

    const [userPublicationDrawer, setUserPublicationDrawer] = useState({
        open: false,
        user: null,
    });

    const handleResourceClick = (resource) => {
        setUserPublicationDrawer({ open: true, user: resource });
    };

    const userDetailData = useSelector(
        (state) => state?.UserManagementReducer?.UserDetailData,
    );
    const userDetailLoader = useSelector(
        (state) => state?.UserManagementReducer?.DetailUserLoader,
    );
    const [userDetailDrawerOpen, setUserDetailDrawerOpen] = useState(false);

    const handleViewUserDetails = (resource) => {
        if (!resource?.id) return;
        dispatch(UserManagementAction.GetUserDetail({ id: Number(resource.id) }));
        setUserDetailDrawerOpen(true);
    };

    const onCloseUserDetailDrawer = () => {
        setUserDetailDrawerOpen(false);
        dispatch(UserManagementAction.UserDetailReset());
    };

    // for handling scrolling and initial call.
    // const fetchingSchedulerRecords = () => {
    //     dispatch(ShiftSchedulerAction.GetShifts(state));
    // }

    // clearing shifts on unmounting as it is creating a repetative data once the component get mounts again.
    useEffect(() => {
        return () => {
            dispatch(ShiftSchedulerAction.ClearShifts());
        };
    }, []);

    const [drawerStates, setDrawerStates] = useState({
        assignShiftDrawer: false,
        shiftTypeDrawer: false,
        typeOfShift: '',
        filter: false,
        openShiftDetailDrawer: false,
    });

    const [resources, setResources] = useState([]);
    const [events, setEvents] = useState([]);
    const [shiftsHasMore, setShiftsHasMore] = useState(true);
    const [assignShiftCase, setAssignShiftCase] = useState(false);
    const [fetchingConditionally, setFetchingConditionally] = useState(false);
    const [filterQueryParams, setFilterQueryParams] = useState('');
    const [totalScheduleObjectCount, setTotalScheduleObjectCount] = useState(0);
    const [forceFullyStopHasMoreShifts, setForceFullyStopHasMoreShifts] =
        useState(false);
    const [propertyLocations, setPropertyLocations] = useState([]);
    const [paginationMetadata, setPaginationMetadata] = useState(null);
    const loadMoreRef = useRef(null);

    const handleLoadMore = () => {
        if (loadMoreRef.current) {
            loadMoreRef.current();
        }
    };

    const [currentConfigOfScheduler, setCurrentConfigOfScheduler] = useState({
        date: dayjs().format('YYYY-MM-DD') || currentDate(),
        viewType: ViewType?.Week,
    });

    const shiftDetailHandler = (
        openShiftDetail,
        allowNew = false,
        isOpenShift,
    ) => {
        setOpenShiftDetail(openShiftDetail);
        if (allowNew) {
            setDrawerStates((prev) => ({
                ...prev,
                assignShiftDrawer: false,
                shiftTypeDrawer: true,
                typeOfShift: isOpenShift ? 'open' : 'normal',
            }));
        } else {
            setDrawerStates({ ...drawerStates, openShiftDetailDrawer: true });
        }
        // setDrawerStates({ ...drawerStates, assignShiftDrawer: true });
    };

    // Scroll to top when new data is updated
    useEffect(() => {
        if (scrollContainerRef.current) {
            util?.scrollPartially(scrollContainerRef);
        }
    }, [state?.page]); // Trigger whenever `data` changes

    useEffect(() => {
        dispatch(ShiftSchedulerAction.ClearShifts());

        let shiftResources = [...resources];
        let shiftEvents = [...events];

        if (assignShiftCase) {
            shiftResources = [];
            shiftEvents = [];
            setEvents([]);
            setResources([]);
            setAssignShiftCase(false);
            setForceFullyStopHasMoreShifts(false);
            setFetchingConditionally(true);
            setTotalScheduleObjectCount(0);
        }

        if (shiftRecords?.length > 0 || shiftRecords?.length === 0) {
            const findCurrent = paginate?.currentPage === 1;

            let updatedResources = findCurrent ? [] : [...shiftResources];
            let updatedEvents = findCurrent ? [] : [...shiftEvents];

            const addOrUpdateResource = (resourceData) => {
                const index = updatedResources.findIndex(
                    (resource) => resource?.email === resourceData?.email,
                );

                if (index !== -1) {
                    const existing = updatedResources[index];

                    updatedResources.splice(index, 1, {
                        ...existing,
                        count: (existing?.count || 0) + 1,
                    });

                    return existing?.id;
                }

                updatedResources.push({
                    ...resourceData,
                    count: 1,
                });

                return resourceData?.id;
            };

            const buildEvent = ({
                item,
                resourceId,
                userData,
                status,
                schedules = '-',
                assignedBy = '-',
                assignedByImage = '',
                bgColor,
                title,
                isOpenShift,
            }) => {
                const startDate = item.shiftDate;
                const endDate = item.shiftDate;

                const startTimeString = `${startDate} ${item.startTime}`;
                const endTimeString = `${endDate} ${item.endTime}`;

                const startTimeMoment = moment(
                    startTimeString,
                    'YYYY-MM-DD HH:mm:ss',
                );

                const endTimeMoment = moment(
                    endTimeString,
                    'YYYY-MM-DD HH:mm:ss',
                );

                return {
                    id: `${isOpenShift ? 'open' : 'normal'}-${item?.id}-${resourceId || ''}`,
                    shiftId: item?.id,
                    break: item?.break,
                    howMany: item?.howMany,
                    start: startTimeMoment,
                    end: endTimeMoment,
                    property: item?.property ? item?.property?.name : '',
                    resourceId,
                    title: title || `${startTimeString} - ${endTimeString}`,
                    bgColor: bgColor || item.siteColor || colorPrimary + '50',
                    location: formatAddress(item?.address),
                    Eligibility: item?.eligibilitity
                        ? item?.eligibilitity?.name
                        : '',
                    Schedules: schedules,
                    assignedBy,
                    assignedByImage,
                    duration: `${startTimeString} - ${endTimeString}`,
                    status,
                    userId: userData?.user?.id,
                    published: state?.published,
                    openShift: isOpenShift,
                    completeRecord: {
                        ...item,
                        openShift: isOpenShift,
                    },
                    shiftDetailHandler,
                };
            };

            for (let item of shiftRecords || []) {
                const isOpenShift = item?.openShift === true;

                const appliedUsers =
                    item?.shiftUser?.filter(
                        (shiftUser) => shiftUser?.status === 'applied',
                    ) || [];

                const acceptedUsers =
                    item?.shiftUser?.filter(
                        (shiftUser) => shiftUser?.status === 'accepted',
                    ) || [];

                const noOfAssigness = item?.numberOfAssignees;

                if (item?.shiftUser?.length > 0) {
                    for (let Users of item.shiftUser) {
                        if (isOpenShift) {
                            if (
                                appliedUsers?.length > 0 &&
                                Users?.status === 'applied' &&
                                acceptedUsers?.length < noOfAssigness
                            ) {
                                updatedEvents.push(
                                    buildEvent({
                                        item,
                                        resourceId: `open-shift-${item?.id}`,
                                        userData: Users,
                                        status: appliedUsers[0]?.status,
                                        schedules: '-',
                                        assignedBy: appliedUsers[0]?.assignee
                                            ? `${appliedUsers[0]?.assignee?.firstName} ${appliedUsers[0]?.assignee?.lastName}`
                                            : '-',
                                        assignedByImage:
                                            Users?.assignee?.profileImg?.[0]
                                                ?.url,
                                        bgColor:
                                            item.siteColor ||
                                            colorPrimary + '50',
                                        isOpenShift: true,
                                    }),
                                );

                                break;
                            }

                            if (Users?.status !== 'applied') {
                                updatedEvents.push(
                                    buildEvent({
                                        item,
                                        resourceId: `open-shift-${item?.id}`,
                                        userData: Users,
                                        status: Users?.status,
                                        schedules: Users?.user?.schedules?.[0]
                                            ?.name
                                            ? `${Users?.user?.schedules?.[0]?.name}...`
                                            : '-',
                                        assignedBy: Users?.assignee
                                            ? `${Users?.assignee?.firstName} ${Users?.assignee?.lastName}`
                                            : '-',
                                        assignedByImage:
                                            Users?.assignee?.profileImg?.[0]
                                                ?.url,
                                        bgColor: '#428A42',
                                        isOpenShift: true,
                                    }),
                                );
                            }

                            continue;
                        }

                        const resourceId = addOrUpdateResource({
                            id: Users?.user?.id,
                            name: `${Users?.user?.firstName} ${Users?.user?.lastName}`,
                            image: Users?.user?.profileImg
                                ? Users?.user?.profileImg[0]?.url
                                : avatar,
                            phoneNo: Users?.user?.phoneNo,
                            email: Users?.user?.email,
                            assignee: Users?.assignee,
                        });

                        const startTimeString = `${item.shiftDate} ${item.startTime}`;

                        updatedEvents.push(
                            buildEvent({
                                item,
                                resourceId,
                                userData: Users,
                                status: Users?.status,
                                schedules: Users?.user?.schedules?.[0]?.name
                                    ? `${Users?.user?.schedules?.[0]?.name}...`
                                    : '-',
                                assignedBy: Users?.assignee
                                    ? `${Users?.assignee?.firstName} ${Users?.assignee?.lastName}`
                                    : '-',
                                assignedByImage:
                                    Users?.assignee?.profileImg?.[0]?.url,
                                bgColor:
                                    Users?.status === 'accepted'
                                        ? '#5fdba7'
                                        : item.siteColor || colorPrimary + '50',
                                title:
                                    dayjs(startTimeString)?.format('HH:mm') +
                                    (formatAddress(item?.address)
                                        ? ` - ${formatAddress(item?.address)}`
                                        : ''),
                                isOpenShift: false,
                            }),
                        );
                    }
                } else if (isOpenShift) {
                    updatedEvents.push(
                        buildEvent({
                            item,
                            resourceId: `open-shift-${item?.id}`,
                            userData: null,
                            status: 'not applied',
                            schedules: '-',
                            assignedBy: '-',
                            assignedByImage: '',
                            bgColor: item.siteColor || colorPrimary + '50',
                            isOpenShift: true,
                        }),
                    );
                }
            }

            setResources(updatedResources);
            setEvents(updatedEvents);
        }
    }, [shiftRecords, assignShiftCase]);

    const { data: eligibilityOptions } = useQuery('eligiblity', getEligibiity, {
        enabled: drawerStates.filter,
    });
    const { data: scheduleOptions } = useQuery('schedule', getSchedules, {
        enabled: drawerStates.filter,
    });

    const { data: usersOptions } = useQuery(
        ['users'], // queryKey
        () => getAllUsers('', '', 'fullName'), // queryFn
        {
            enabled: drawerStates.filter, // options
        },
    );

    const { data: propertiesRaw } = useQuery(
        'properties',
        getAllProperties,
        {
            enabled: drawerStates.filter,
        },
    );

    const propertiesOptions = (propertiesRaw || []).map((p) => ({
        label: p.name,
        value: p.id,
    }));

    // Fetch locations when property is selected
    useEffect(() => {
        const fetchLocations = async () => {
            if (state?.filterDrawer?.jobSite) {
                const locations = await getLocationsByProperty(
                    state.filterDrawer.jobSite,
                );
                setPropertyLocations(locations);
            } else {
                setPropertyLocations([]);
            }
            // Always reset location when job site changes
            setState((prev) => ({
                ...prev,
                filterDrawer: {
                    ...prev.filterDrawer,
                    location: '',
                },
            }));
        };
        fetchLocations();
    }, [state?.filterDrawer?.jobSite]);

    // to select a shift from open or normal
    const assignShiftHandler = () => {
        setDrawerStates({ ...drawerStates, assignShiftDrawer: true });
    };

    // type of drawer open on the basis of type selection for shift
    const shiftTypeHandler = (type, prefilledData = null) => {
        setDrawerStates((prev) => ({
            ...prev,
            assignShiftDrawer: false,
            shiftTypeDrawer: true,
            typeOfShift: type,
            prefilledData: prefilledData,
        }));
    };

    const paginationHandler = (page, limit) => {
        const { schedule, user, eligiblity } = state?.filterDrawer;
        const { tabKey } = state;
        setState((prev) => ({
            ...prev,
            page: page,
            limit: 100,
            filterDrawer: {
                schedule: schedule,
                user: user,
                eligiblity: eligiblity,
            },
        }));
        setResources([]);
        setEvents([]);
        dispatch(
            ShiftSchedulerAction.GetShifts({
                page,
                limit,
                tabKey,
                filterDrawer: {
                    schedule,
                    user,
                    eligiblity,
                },
            }),
        );
    };

    // filter search handler
    const incidentFilters = () => {
        const { schedule, user, eligiblity, jobSite, location, shiftDate } =
            state.filterDrawer;

        let values = Object.values(state.filterDrawer).some(
            (item) => item !== '',
        );
        if (!values) {
            return;
        } else {
            setState((prev) => ({
                ...prev,
                page: 1,
                filterDrawer: {
                    schedule: schedule,
                    user: user,
                    eligiblity: eligiblity,
                    jobSite: jobSite,
                    location: location,
                    shiftDate: shiftDate,
                },
            }));
            let payload = {
                limit: state?.limit,
                page: 1,
                tabKey: state?.tabKey,
                filterDrawer: {
                    schedule: schedule ? schedule : '',
                    user: user ? user : '',
                    eligiblity: eligiblity ? eligiblity : '',
                    jobSite: jobSite ? jobSite : '',
                    location: location ? location : '',
                    shiftDate: shiftDate ? shiftDate : '',
                },
            };
            setResources([]);
            setEvents([]);
            // dispatch(ShiftSchedulerAction.GetShifts(payload));
            setDrawerStates({ ...drawerStates, filter: false });
            dispatch(ShiftSchedulerAction.ClearShifts());
            setFetchingConditionally(true);
            setForceFullyStopHasMoreShifts(false);
            setTotalScheduleObjectCount(0);
            setFilterQueryParams(
                `&schedule_id=${payload?.filterDrawer?.schedule}&user_id=${payload?.filterDrawer?.user}&eligibility_id=${payload?.filterDrawer?.eligiblity}&property_id=${payload?.filterDrawer?.jobSite}&location_id=${payload?.filterDrawer?.location}&shift_date=${payload?.filterDrawer?.shiftDate}`,
            );
        }
    };

    // Filter states cleaner
    const clearFilters = () => {
        if (drawerStates.filter) {
            setState((prev) => ({
                ...prev,
                limit: state?.limit,
                page: 1,
                filterDrawer: {
                    schedule: '',
                    user: '',
                    eligiblity: '',
                    jobSite: '',
                    location: '',
                    shiftDate: '',
                },
            }));
            let payload = {
                limit: state?.limit,
                page: 1,
                tabKey: state?.tabKey,
                filterDrawer: {
                    schedule: '',
                    user: '',
                    eligiblity: '',
                    jobSite: '',
                    location: '',
                    shiftDate: '',
                },
            };
            setResources([]);
            setEvents([]);
            // dispatch(ShiftSchedulerAction.GetShifts(payload));
            setDrawerStates({ ...drawerStates, filter: false });
            dispatch(ShiftSchedulerAction.ClearShifts());
            setFetchingConditionally(true);
            setForceFullyStopHasMoreShifts(false);
            setTotalScheduleObjectCount(0);
            setFilterQueryParams('');
        }
        return;
    };

    console.log('eventsNresources', events, resources);

    const tabChangeHandler = (activeKey) => {
        setState({
            ...state,
            page: 1,
            tabKey: activeKey,
            filterDrawer: { ...state.filterDrawer },
        });
        // dispatch(
        //     ShiftSchedulerAction.GetShifts({
        //         ...state,
        //         tabKey: activeKey,
        //         page: 1,
        //     }),
        // );
        dispatch(ShiftSchedulerAction.ClearShifts());
        setFetchingConditionally(true);
        setForceFullyStopHasMoreShifts(false);
        setTotalScheduleObjectCount(0);
        setEvents([]);
        setResources([]);
    };

    console.log('currentConfigOfScheduler', currentConfigOfScheduler);

    // data receiving from the scroller component.
    const schedulerScrollDataHandler = (resp) => {
        dispatch(ShiftSchedulerAction.GetShiftsSuccess(resp?.data));
        // handling forcefully stop hasMore scenerio for the scroll component to not show loading state.
        let totalCurrentSchedulesCount =
            totalScheduleObjectCount + state?.limit;
        if (totalCurrentSchedulesCount >= resp?.data?.paginate?.total) {
            setForceFullyStopHasMoreShifts(true);
        } else {
            setForceFullyStopHasMoreShifts(false);
        }
        setTotalScheduleObjectCount(totalCurrentSchedulesCount);
        setState({ ...state, page: resp?.data?.paginate?.currentPage });
        return resp?.data?.data;
    };

    const setFetchingConditinonallySuccessCallback = () => {
        setFetchingConditionally(false);
    };

    const [ShiftLoader, setShiftLoader] = useState(true);

    return (
        <>
            <BasicDrawer
                openDrawer={drawerStates?.assignShiftDrawer}
                width={400}
                title={'Select the type of Shift'}
                onClose={() =>
                    setDrawerStates((prev) => ({
                        ...prev,
                        assignShiftDrawer: false,
                    }))
                }
                children={
                    <Row
                        className="w-full mt-4 flex justify-around gap-3 flex-wrap"
                        gutter={[16, 32]}
                    >
                        <Col
                            span={10}
                            onClick={() => shiftTypeHandler('open')}
                            style={{ background: colorPrimary, color: 'white' }}
                            className="flex items-center justify-center rounded-md p-4 cursor-pointer hover:scale-x-105 hover:scale-y-105 duration-500 ease-in-out delay-75"
                        >
                            <div>
                                <BasicText
                                    text={'Open Shift'}
                                    className="text-lg "
                                />
                            </div>
                        </Col>

                        <Col
                            span={10}
                            onClick={() => shiftTypeHandler('normal')}
                            style={{ background: colorPrimary, color: 'white' }}
                            className="flex items-center justify-center gap-3 p-4 rounded-md cursor-pointer hover:scale-x-105 hover:scale-y-105 duration-500 ease-in-out delay-75"
                        >
                            <div>
                                <BasicText
                                    text={'Normal Shift'}
                                    className="text-lg "
                                />
                            </div>
                        </Col>
                    </Row>
                }
            />

            <AssignShiftDrawer
                drawerStates={drawerStates}
                setDrawerStates={setDrawerStates}
                shiftState={state}
                openShiftDetailData={openShiftDetail}
                setShiftState={setState}
                setAssignShiftCase={setAssignShiftCase}
                setOpenShiftDetail={setOpenShiftDetail}
            />

            {/* scheduler component */}
            <Row
                className="w-full py-5 px-2"
                style={{ width: '100%', background: 'white' }}
            >
                <Col
                    span={24}
                    className="px-2 flex items-center justify-between gap-3 flex-wrap"
                >
                    <div className="flex items-center gap-3 min-w-0 flex-wrap">
                        <div
                            className="flex items-center gap-2 cursor-pointer shrink-0"
                            onClick={() => navigate('/workforce-management')}
                            style={{ color: '#555', userSelect: 'none' }}
                        >
                            <IoArrowBack size={18} />
                            {/* <span>Back</span> */}
                        </div>
                        <BasicText
                            text={'Workforce Management - Shift Scheduler'}
                            className="text-lg md:text-xl font-semibold"
                        />
                    </div>

                    <div className="flex items-center gap-2 flex-wrap justify-end">
                        {(userRole === 'admin' || userRole === 'manager' || userRole === 'supervisor') && (
                            <>
                                <Button.Basic
                                    className="text-white outline-none border-none cursor-pointer px-4 whitespace-nowrap"
                                    style={{ height: '40px', background: colorPrimary, color: Colors.White }}
                                    text="Open Shift"
                                    icon={<PlusOutlined />}
                                    onClick={() => shiftTypeHandler('open')}
                                />
                                <Button.Basic
                                    className="text-white outline-none border-none cursor-pointer px-4 whitespace-nowrap"
                                    style={{ height: '40px', background: colorPrimary, color: Colors.White }}
                                    text="Normal Shift"
                                    icon={<PlusOutlined />}
                                    onClick={() => shiftTypeHandler('normal')}
                                />
                            </>
                        )}
                        <button
                            onClick={() => events?.length > 0 && convertToPdf(printRef, { orientation: 'landscape', filename: 'shift-scheduler.pdf' })}
                            title="Print Scheduler"
                            style={{
                                background: events?.length > 0 ? colorPrimary : '#d9d9d9',
                                border: 'none',
                                borderRadius: 6,
                                padding: '7px 10px',
                                cursor: events?.length > 0 ? 'pointer' : 'not-allowed',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: 40,
                                width: 40,
                                flexShrink: 0,
                            }}
                        >
                            <PrinterOutlined style={{ fontSize: 16, color: 'white' }} />
                        </button>
                        <FaFilter
                            size={35}
                            color="white"
                            style={{ background: colorPrimary, flexShrink: 0, height: 40, width: 40, }}
                            className="cursor-pointer p-2 rounded-md"
                            onClick={() =>
                                setDrawerStates({ ...drawerStates, filter: true })
                            }
                        />
                    </div>
                </Col>

                {/* <Col span={24} className="mt-4">
                    <Tabs
                        type="card"
                        activeKey={state?.tabKey}
                        onChange={ShiftLoader ? () => { } : tabChangeHandler}
                        defaultActiveKey={state?.tabKey}
                        items={[
                            {
                                label: `Normal Shifts`,
                                key: 0,
                                children: ``,
                            },
                            {
                                label: `Open Shifts`,
                                key: 1,
                                children: ``,
                            },
                        ]}
                    />
                </Col> */}

                {/* NOTE: no blocking spinner here. <LoadOnScroll /> is what actually
                    fetches the shifts, so it must stay mounted; unmounting it behind a
                    loader deadlocked the page (no request => loader never turned off).
                    The first call shows the same inline "Loading..." pill as Load More,
                    rendered by CustomCalendar from the isLoadingMore prop. */}
                    <>
                        <div
                            id="scrollableDiv"
                            ref={scrollContainerRef}
                            style={{
                                // height:
                                //     resources?.length < 4 ? 220 : 'fit-content',
                                // maxHeight: 300,
                                overflow: 'auto',
                                width: '100%',
                            }}
                        >
                            <LoadOnScroll
                                itsAllowOpen={true}
                                endPoint={`/shifts`}
                                restQueryParams={`perPage=${state?.limit}&open_shift=${0}${filterQueryParams?.length > 0 ? filterQueryParams : ''}`}
                                restQueryOpenShiftParams={`perPage=${state?.limit}&open_shift=${1}${filterQueryParams?.length > 0 ? filterQueryParams : ''}`}
                                // height={300}
                                scrollableTarget="scrollableDiv"
                                hasMore={shiftsHasMore}
                                setHasMore={setShiftsHasMore}
                                // fetching conditionally case when we are assigning shift then we have to fetched the data to update.
                                isFetchConditionally={fetchingConditionally}
                                setIsFetchingConditionally={
                                    setFetchingConditionally
                                }
                                // callback from the child to parent.
                                callback={
                                    setFetchingConditinonallySuccessCallback
                                }
                                scrollItems={events}
                                scrollDataHandler={schedulerScrollDataHandler}
                                stopHasMoreScenerioConditionally={
                                    forceFullyStopHasMoreShifts
                                }
                                scrollThreshold={1}
                                endMessage={
                                    ShiftLoader
                                        ? 'Loading...'
                                        : 'No more shifts to show'
                                }
                                loadingSpinner={ShiftLoader}
                                setShiftLoader={setShiftLoader}
                                handlePaginationMetadata={setPaginationMetadata}
                                loadMoreRef={loadMoreRef}
                                children={
                                    <App
                                        tabKey={state?.tabKey}
                                        events={events}
                                        resources={resources}
                                        currentSchedulerState={state}
                                        currentConfigOfScheduler={
                                            currentConfigOfScheduler
                                        }
                                        setCurrentConfigOfScheduler={
                                            setCurrentConfigOfScheduler
                                        }
                                        paginationMetadata={paginationMetadata}
                                        onLoadMore={handleLoadMore}
                                        isLoadingMore={ShiftLoader}
                                        onResourceClick={handleResourceClick}
                                        shiftTypeHandler={shiftTypeHandler}
                                        onViewChange={(v) =>
                                            setCurrentConfigOfScheduler((prev) => ({
                                                ...prev,
                                                viewType: v === 'day' ? 0 : 1,
                                            }))
                                        }
                                        onDateChange={(d) => setPrintSelectedDate(d)}
                                    />
                                }
                            />
                        </div>
                        {/* <Col
                            span={24}
                            className="flex items-center justify-end"
                        >
                            <Pagination.Basic
                                total={paginate?.total}
                                pageSize={state?.limit}
                                current={state?.page}
                                onChange={paginationHandler}
                                showSizeChanger={''}
                                containerStyle={{ marginRight: '24px' }}
                            />
                        </Col> */}
                    </>
            </Row>

            {/* Filter drawer */}
            <BasicDrawer
                openDrawer={drawerStates?.filter}
                onClose={() =>
                    setDrawerStates({ ...drawerStates, filter: false })
                }
                width={300}
                title={'Filters'}
                children={
                    <>
                        <Row
                            gutter={[16, 32]}
                            className="flex w-full flex-col h-full justify-between"
                        >
                            <Row gutter={[1, 12]} className="w-full">
                                <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        Schedule
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    optionSelectedBg:
                                                        colorPrimary,
                                                    optionActiveBg:
                                                        Colors.LightGray,
                                                    optionSelectedColor:
                                                        Colors.White,
                                                    selectorBg:
                                                        Colors.LightGray,
                                                },
                                            },
                                        }}
                                    >
                                        <Select
                                            allowClear={true}
                                            className="w-full h-9 outline-none rounded"
                                            value={
                                                state?.filterDrawer?.schedule
                                            }
                                            onChange={(value) => {
                                                if (
                                                    value !== undefined &&
                                                    value !== null
                                                ) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            schedule: value,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            schedule: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            options={
                                                scheduleOptions
                                                    ? scheduleOptions
                                                    : []
                                            }
                                        />
                                    </ConfigProvider>
                                </Col>

                                <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        User
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    optionSelectedBg:
                                                        colorPrimary,
                                                    optionActiveBg:
                                                        Colors.LightGray,
                                                    optionSelectedColor:
                                                        Colors.White,
                                                    selectorBg:
                                                        Colors.LightGray,
                                                },
                                            },
                                        }}
                                    >
                                        <Select
                                            allowClear={true}
                                            className="w-full h-9 outline-none rounded"
                                            value={state?.filterDrawer?.user}
                                            onChange={(value) => {
                                                if (
                                                    value !== undefined &&
                                                    value !== null
                                                ) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            user: value,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            user: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            options={
                                                usersOptions ? usersOptions : []
                                            }
                                            showSearch={true}
                                            filterOption={(input, option) =>
                                                (option?.label ?? '')
                                                    .toLowerCase()
                                                    .includes(
                                                        input.toLowerCase(),
                                                    )
                                            }
                                        />
                                    </ConfigProvider>
                                </Col>

                                <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        Position
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    optionSelectedBg:
                                                        colorPrimary,
                                                    optionActiveBg:
                                                        Colors.LightGray,
                                                    optionSelectedColor:
                                                        Colors.White,
                                                    selectorBg:
                                                        Colors.LightGray,
                                                },
                                            },
                                        }}
                                    >
                                        <Select
                                            allowClear={true}
                                            className="w-full h-9 outline-none rounded"
                                            value={
                                                state?.filterDrawer?.eligiblity
                                            }
                                            onChange={(value) => {
                                                if (
                                                    value !== undefined &&
                                                    value !== null
                                                ) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            eligiblity: value,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            eligiblity: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            options={
                                                eligibilityOptions
                                                    ? eligibilityOptions
                                                    : []
                                            }
                                        />
                                    </ConfigProvider>
                                </Col>

                                <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        Job Site
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    optionSelectedBg:
                                                        colorPrimary,
                                                    optionActiveBg:
                                                        Colors.LightGray,
                                                    optionSelectedColor:
                                                        Colors.White,
                                                    selectorBg:
                                                        Colors.LightGray,
                                                },
                                            },
                                        }}
                                    >
                                        <Select
                                            allowClear={true}
                                            className="w-full h-9 outline-none rounded"
                                            value={state?.filterDrawer?.jobSite}
                                            onChange={(value) => {
                                                if (
                                                    value !== undefined &&
                                                    value !== null
                                                ) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            jobSite: value,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            jobSite: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            options={
                                                propertiesOptions
                                                    ? propertiesOptions
                                                    : []
                                            }
                                        />
                                    </ConfigProvider>
                                </Col>

                                <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        Location
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                Select: {
                                                    optionSelectedBg:
                                                        colorPrimary,
                                                    optionActiveBg:
                                                        Colors.LightGray,
                                                    optionSelectedColor:
                                                        Colors.White,
                                                    selectorBg:
                                                        Colors.LightGray,
                                                },
                                            },
                                        }}
                                    >
                                        <Select
                                            allowClear={true}
                                            disabled={
                                                !state?.filterDrawer?.jobSite
                                            }
                                            className="w-full h-9 outline-none rounded"
                                            value={
                                                state?.filterDrawer?.location ||
                                                undefined
                                            }
                                            onChange={(value) => {
                                                if (
                                                    value !== undefined &&
                                                    value !== null
                                                ) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            location: value,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            location: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            placeholder="Select location"
                                            options={propertyLocations}
                                        />
                                    </ConfigProvider>
                                </Col>

                                <Col span={24}>
                                    <label
                                        className="font-normal"
                                        style={{ color: Colors.LabelColor }}
                                    >
                                        Shift Date
                                    </label>
                                    <ConfigProvider
                                        theme={{
                                            components: {
                                                DatePicker: {
                                                    cellActiveWithRangeBg:
                                                        colorPrimary,
                                                    cellHoverBg:
                                                        Colors.LightGray,
                                                },
                                            },
                                        }}
                                    >
                                        <DatePicker
                                            allowClear={true}
                                            className="w-full h-9 outline-none rounded"
                                            value={
                                                state?.filterDrawer?.shiftDate
                                                    ? dayjs(
                                                        state?.filterDrawer
                                                            ?.shiftDate,
                                                    )
                                                    : null
                                            }
                                            onChange={(date, dateString) => {
                                                if (date) {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            shiftDate:
                                                                dateString,
                                                        },
                                                    }));
                                                } else {
                                                    setState((prev) => ({
                                                        ...prev,
                                                        filterDrawer: {
                                                            ...prev.filterDrawer,
                                                            shiftDate: '',
                                                        },
                                                    }));
                                                }
                                            }}
                                            format="YYYY-MM-DD"
                                        />
                                    </ConfigProvider>
                                </Col>
                            </Row>

                            <Row
                                className="w-full flex justify-between gap-4 px-2 self-end"
                                align={'middle'}
                            >
                                <Col span={11}>
                                    <Button.Basic
                                        onClick={incidentFilters}
                                        style={{
                                            color: 'white',
                                            backgroundColor: colorPrimary,
                                        }}
                                        text={'Search'}
                                        className={'w-full rounded'}
                                        size={'large'}
                                    />
                                </Col>
                                <Col span={11}>
                                    <Button.Basic
                                        onClick={clearFilters}
                                        style={{
                                            color: 'white',
                                            backgroundColor: Colors.Error,
                                        }}
                                        text={'Clear'}
                                        className={'w-full rounded'}
                                        size={'large'}
                                    />
                                </Col>
                            </Row>
                        </Row>
                    </>
                }
            />

            {/* Detail shift drawer only for the open shifts it will open in case of status is Applied  */}
            <DetailShiftDrawer
                drawerStates={drawerStates}
                setDrawerStates={setDrawerStates}
                openShiftDetailData={openShiftDetail}
                state={state}
                setState={setState}
                setOpenShiftDetail={setOpenShiftDetail}
                setAssignShiftCase={setAssignShiftCase}
            />

            {/* User publication status drawer */}
            <UserPublicationDrawer
                open={userPublicationDrawer.open}
                selectedUser={userPublicationDrawer.user}
                currentConfigOfScheduler={currentConfigOfScheduler}
                onClose={() =>
                    setUserPublicationDrawer({ open: false, user: null })
                }
                onUpdateSuccess={() => setAssignShiftCase(true)}
                onViewUserDetails={handleViewUserDetails}
            />

            {/* User details drawer (view only, reused from User Management) */}
            <UserDetailDrawer
                drawerStates={{ userDetailDrawer: userDetailDrawerOpen }}
                onCloseDrawer={onCloseUserDetailDrawer}
                detailDrawerReset={() => {}}
                userDetailLoader={userDetailLoader}
                userDetailData={userDetailData}
                UserEditHandler={() => {}}
                isRole={userRole}
                hideEditButton
            />

            {/* ======== HIDDEN PRINT LAYOUT ======== */}
            <div style={{ position: 'absolute', top: '-9999px', left: '-9999px' }}>
                <div
                    ref={printRef}
                    style={{
                        /* Letter landscape inner width ≈ 10.5 in @ 96dpi = 1008px, minus margins */
                        width: '1050px',
                        padding: '20px 28px',
                        background: '#fff',
                        color: '#000',
                        fontFamily: 'sans-serif',
                        boxSizing: 'border-box',
                    }}
                >
                    {/* ── Common header ── */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '10px', marginBottom: '16px', color: '#666' }}>
                        <span>Printed: {new Date().toLocaleString()}</span>
                        <span style={{ fontWeight: 700, fontSize: '12px' }}>Workforce Management – Shift Scheduler</span>
                        <span style={{ visibility: 'hidden' }}>Printed: {new Date().toLocaleString()}</span>
                    </div>

                    <h1 style={{ fontSize: '20px', fontWeight: '600', color: '#1a1a2e', margin: '0 0 12px 0' }}>
                        Shift Scheduler
                    </h1>

                    {/* ── Meta row ── */}
                    <div style={{ display: 'flex', gap: '28px', fontSize: '11px', marginBottom: '20px', color: '#444', flexWrap: 'wrap', paddingBottom: '12px', borderBottom: '1px solid #e0e0e0' }}>
                        <span>
                            <strong>Date:</strong>&nbsp;
                            {currentConfigOfScheduler?.viewType === 0
                                ? moment(printSelectedDate).format('MMMM D, YYYY')
                                : (() => {
                                    const base = dayjs(printSelectedDate || currentConfigOfScheduler?.date || undefined);
                                    const ws = base.subtract(base.day(), 'day');
                                    return `${ws.format('MMM D')} – ${ws.add(6, 'day').format('MMM D, YYYY')}`;
                                })()}
                        </span>
                        <span>
                            <strong>View:</strong>&nbsp;
                            {currentConfigOfScheduler?.viewType === 0 ? 'Day' : 'Week'}
                        </span>
                        <span><strong>Total Shifts:</strong>&nbsp;
                            {currentConfigOfScheduler?.viewType === 0
                                ? events.filter(ev => ev.start && moment(new Date(ev.start)).format('YYYY-MM-DD') === moment(printSelectedDate).format('YYYY-MM-DD')).length
                                : (events?.length ?? 0)}
                        </span>
                        <span><strong>Total Staff:</strong>&nbsp;{resources?.length ?? 0}</span>
                    </div>

                    {/* ════════════════════════════════════════════
                        WEEK VIEW PRINT  (viewType === 1)
                        Grid: Resource | Sun | Mon | Tue | Wed | Thu | Fri | Sat
                        Each day cell lists the shift time ranges
                    ════════════════════════════════════════════ */}
                    {currentConfigOfScheduler?.viewType !== 0 && (() => {
                        // Mirror the on-screen week: CustomCalendar rewinds to Sunday of the selected date
                        const base = dayjs(printSelectedDate || currentConfigOfScheduler?.date || undefined);
                        const weekStart = base.subtract(base.day(), 'day'); // .day() = 0 Sun … 6 Sat
                        const weekDays = Array.from({ length: 7 }, (_, i) => weekStart.add(i, 'day'));

                        return (
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '10px', tableLayout: 'fixed', borderTop: '2px solid #c8d6e5' }}>
                                <colgroup>
                                    {/* Resource column ~135px; remaining 7 day cols split equally */}
                                    <col style={{ width: '135px' }} />
                                    {weekDays.map((_, i) => <col key={i} style={{ width: `${(100 - 13).toFixed(1)}%` }} />)}
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th style={{ ...schedulerPrintThStyle, textAlign: 'left', paddingLeft: 8, width: '135px' }}>Resource</th>
                                        {weekDays.map((d) => (
                                            <th key={d.format('YYYY-MM-DD')} style={{ ...schedulerPrintThStyle, textAlign: 'center' }}>
                                                <div style={{ fontWeight: 700, fontSize: 11 }}>{d.format('ddd')}</div>
                                                <div style={{ fontWeight: 400, color: '#666', fontSize: 9 }}>{d.format('MM/DD/YYYY')}</div>
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Open Shifts row */}
                                    {(() => {
                                        const openEvents = events.filter(ev => ev.openShift);
                                        if (openEvents.length === 0) return null;
                                        return (
                                            <tr style={{ background: '#e6f7f3' }}>
                                                <td style={{ ...schedulerPrintTdStyle, fontWeight: 700, textAlign: 'left', paddingLeft: 8, color: '#155f47' }}>
                                                    Open Shifts
                                                </td>
                                                {weekDays.map((d) => {
                                                    const dateStr = d.format('YYYY-MM-DD');
                                                    const dayOpenEvs = openEvents.filter(ev => ev.start && moment(new Date(ev.start)).format('YYYY-MM-DD') === dateStr);
                                                    return (
                                                        <td key={dateStr} style={{ ...schedulerPrintTdStyle, verticalAlign: 'top' }}>
                                                            {dayOpenEvs.map((ev, i) => (
                                                                <div key={i} style={{
                                                                    background: '#1a7a5e',
                                                                    color: '#fff',
                                                                    borderRadius: 3,
                                                                    padding: '10px 5px',
                                                                    marginBottom: 2,
                                                                    fontSize: 9,
                                                                    lineHeight: '1',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    textAlign: 'center',
                                                                    width: 'fit-content',
                                                                    margin: '0 auto 2px auto',
                                                                }}>
                                                                    {ev.start ? moment(new Date(ev.start)).format('hh:mm A') : ''} – {ev.end ? moment(new Date(ev.end)).format('hh:mm A') : ''}
                                                                </div>
                                                            ))}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })()}

                                    {/* Normal staff rows */}
                                    {resources.map((resource, rIdx) => {
                                        const resourceEvents = events.filter(ev => ev.resourceId === resource.id);
                                        return (
                                            <tr key={resource.id} style={{ background: rIdx % 2 === 0 ? '#fff' : '#f9fafe' }}>
                                                <td style={{ ...schedulerPrintTdStyle, fontWeight: 600, textAlign: 'left', paddingLeft: 8, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    {resource.name}
                                                </td>
                                                {weekDays.map((d) => {
                                                    const dateStr = d.format('YYYY-MM-DD');
                                                    const dayEvs = resourceEvents.filter(ev => ev.start && moment(new Date(ev.start)).format('YYYY-MM-DD') === dateStr);
                                                    return (
                                                        <td key={dateStr} style={{ ...schedulerPrintTdStyle, verticalAlign: 'top', padding: '4px' }}>
                                                            {dayEvs.map((ev, i) => (
                                                                <div key={i} style={{
                                                                    background: ev.status === 'accepted' ? '#5fdba7' : '#1a7a5e',
                                                                    color: '#fff',
                                                                    borderRadius: 3,
                                                                    padding: '10px 5px',
                                                                    marginBottom: 2,
                                                                    fontSize: 9,
                                                                    lineHeight: '1',
                                                                    whiteSpace: 'nowrap',
                                                                    overflow: 'hidden',
                                                                    textOverflow: 'ellipsis',
                                                                    textAlign: 'center',
                                                                    width: 'fit-content',
                                                                    margin: '0 auto 2px auto',
                                                                }}>
                                                                    {ev.start ? moment(new Date(ev.start)).format('hh:mm A') : ''} – {ev.end ? moment(new Date(ev.end)).format('hh:mm A') : ''}
                                                                </div>
                                                            ))}
                                                        </td>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}

                                    {resources.length === 0 && (
                                        <tr>
                                            <td colSpan={8} style={{ ...schedulerPrintTdStyle, color: '#aaa', textAlign: 'center', padding: 20 }}>
                                                No shift records to display
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                {/* Summary footer */}
                                {/* <tfoot>
                                    <tr style={{ background: '#f0f4ff' }}>
                                        <td style={{ ...schedulerPrintTdStyle, fontWeight: 700 }}>TOTAL</td>
                                        {weekDays.map((d) => {
                                            const dateStr = d.format('YYYY-MM-DD');
                                            const count = events.filter(ev => ev.start && moment(new Date(ev.start)).format('YYYY-MM-DD') === dateStr).length;
                                            return (
                                                <td key={dateStr} style={{ ...schedulerPrintTdStyle, fontWeight: 600, color: count > 0 ? '#1a7a5e' : '#aaa' }}>
                                                    {count > 0 ? `${count} shift${count !== 1 ? 's' : ''}` : '—'}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                </tfoot> */}
                            </table>
                        );
                    })()}

                    {/* ════════════════════════════════════════════
                        DAY VIEW PRINT  (viewType === 0)
                        Grid: Resource | 12AM | 1AM | ... | 11PM
                        Shift spans are shown as filled blocks
                    ════════════════════════════════════════════ */}
                    {currentConfigOfScheduler?.viewType === 0 && (() => {
                        // Match on-screen time format: show full 24 hours 0–23
                        const HOURS = Array.from({ length: 24 }, (_, h) => h);
                        // Filter events to the date currently selected in CustomCalendar
                        const selectedDateStr = moment(printSelectedDate).format('YYYY-MM-DD');
                        const dayEvents = events.filter((ev) =>
                            ev.start && moment(new Date(ev.start)).format('YYYY-MM-DD') === selectedDateStr
                        );
                        const formatHour = (h) => {
                            if (h === 0) return '12AM';
                            if (h < 12) return `${h}AM`;
                            if (h === 12) return '12PM';
                            return `${h - 12}PM`;
                        };

                        // Check if shift covers a given hour (0-23)
                        // ev.start/ev.end are moment objects — use new Date() to convert safely
                        const evToDate = (v) => v ? new Date(v) : null;
                        const shiftCoversHour = (ev, hour) => {
                            const s = evToDate(ev.start);
                            const e = evToDate(ev.end);
                            if (!s || !e) return false;
                            const startH = s.getHours() + s.getMinutes() / 60;
                            const endH = e.getHours() + e.getMinutes() / 60;
                            return hour >= Math.floor(startH) && hour < Math.ceil(endH);
                        };
                        const fmtTime = (v) => v ? moment(new Date(v)).format('hh:mm A') : '';

                        const getLayers = (evs) => {
                            const layers = [];
                            [...evs].sort((a, b) => evToDate(a.start) - evToDate(b.start)).forEach(ev => {
                                let placed = false;
                                for (let layer of layers) {
                                    const overlaps = layer.some(layerEv => {
                                        return evToDate(ev.start) < evToDate(layerEv.end) && evToDate(ev.end) > evToDate(layerEv.start);
                                    });
                                    if (!overlaps) {
                                        layer.push(ev);
                                        placed = true;
                                        break;
                                    }
                                }
                                if (!placed) layers.push([ev]);
                            });
                            return layers;
                        };

                        const renderLayerCells = (layer) => {
                            const cells = [];
                            let h = 0;
                            while (h < 24) {
                                const covered = layer.find(ev => shiftCoversHour(ev, h));
                                if (covered) {
                                    let span = 0;
                                    while (h + span < 24 && shiftCoversHour(covered, h + span)) {
                                        span++;
                                    }
                                    cells.push({ type: 'event', event: covered, span, startHour: h });
                                    h += span;
                                } else {
                                    cells.push({ type: 'empty', span: 1, startHour: h });
                                    h += 1;
                                }
                            }
                            return cells.map((cell, idx) => {
                                if (cell.type === 'empty') {
                                    return <td key={idx} style={{ ...schedulerPrintTdStyle, border: '1px solid #e8ecef' }}></td>;
                                } else {
                                    const ev = cell.event;
                                    return (
                                        <td key={idx} colSpan={cell.span} style={{ ...schedulerPrintTdStyle, border: '1px solid #e8ecef', padding: '2px' }}>
                                            <div style={{
                                                background: ev.status === 'accepted' ? '#5fdba7' : '#1a7a5e',
                                                color: ev.status === 'accepted' ? '#155f47' : '#fff',
                                                borderRadius: 4,
                                                padding: '10px 5px',
                                                fontSize: 7,
                                                lineHeight: '1',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                textAlign: 'center',
                                            }}>
                                                {fmtTime(ev.start)} – {fmtTime(ev.end)}
                                                {ev.location && !ev.openShift ? ` at ${ev.location}` : ''}
                                            </div>
                                        </td>
                                    );
                                }
                            });
                        };

                        return (
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '8px', tableLayout: 'fixed', borderTop: '2px solid #c8d6e5' }}>
                                <colgroup>
                                    {/* Resource column fixed; 24 hour cols share remaining space equally */}
                                    <col style={{ width: '120px' }} />
                                    {HOURS.map((h) => <col key={h} />)}
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th style={{ ...schedulerPrintThStyle, textAlign: 'left', paddingLeft: 6, fontSize: 9, width: '120px' }}>Resource</th>
                                        {HOURS.map((h) => (
                                            <th key={h} style={{ ...schedulerPrintThStyle, padding: '4px 1px', fontSize: 7, whiteSpace: 'nowrap', textAlign: 'center' }}>
                                                {formatHour(h)}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* Open Shifts rows */}
                                    {(() => {
                                        const openEvents = dayEvents.filter(ev => ev.openShift);
                                        if (openEvents.length === 0) return null;
                                        const layers = getLayers(openEvents);
                                        return layers.map((layer, lIdx) => (
                                            <tr key={`open-${lIdx}`} style={{ background: '#e6f7f3' }}>
                                                {lIdx === 0 && (
                                                    <td rowSpan={layers.length} style={{ ...schedulerPrintTdStyle, fontWeight: 700, textAlign: 'left', paddingLeft: 6, fontSize: 9, color: '#155f47', verticalAlign: 'top', paddingTop: 6 }}>
                                                        Open Shifts
                                                    </td>
                                                )}
                                                {renderLayerCells(layer)}
                                            </tr>
                                        ));
                                    })()}

                                    {/* Staff rows */}
                                    {resources.map((resource, rIdx) => {
                                        const resourceEvents = dayEvents.filter(ev => ev.resourceId === resource.id);
                                        const layers = getLayers(resourceEvents);
                                        if (layers.length === 0) {
                                            return (
                                                <tr key={resource.id} style={{ background: rIdx % 2 === 0 ? '#fff' : '#f9fafe' }}>
                                                    <td style={{ ...schedulerPrintTdStyle, fontWeight: 600, textAlign: 'left', paddingLeft: 6, fontSize: 9, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                        {resource.name}
                                                    </td>
                                                    {Array.from({ length: 24 }).map((_, i) => (
                                                        <td key={i} style={{ ...schedulerPrintTdStyle, border: '1px solid #e8ecef' }}></td>
                                                    ))}
                                                </tr>
                                            );
                                        }
                                        return layers.map((layer, lIdx) => (
                                            <tr key={`${resource.id}-${lIdx}`} style={{ background: rIdx % 2 === 0 ? '#fff' : '#f9fafe' }}>
                                                {lIdx === 0 && (
                                                    <td rowSpan={layers.length} style={{ ...schedulerPrintTdStyle, fontWeight: 600, textAlign: 'left', paddingLeft: 6, fontSize: 9, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', verticalAlign: 'top', paddingTop: 6 }}>
                                                        {resource.name}
                                                    </td>
                                                )}
                                                {renderLayerCells(layer)}
                                            </tr>
                                        ));
                                    })}

                                    {resources.length === 0 && (
                                        <tr>
                                            <td colSpan={25} style={{ ...schedulerPrintTdStyle, color: '#aaa', textAlign: 'center', padding: 20 }}>
                                                No shift records to display
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        );
                    })()}

                    {/* ── Signature ── */}
                    {/* <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '36px', fontSize: '12px', color: '#444' }}>
                        <div>Signature: _________________________________________</div>
                        <div>Date: ________________________</div>
                    </div> */}
                </div>
            </div>
        </>
    );
};

// ── shared print styles ───────────────────────────────────────
const schedulerPrintThStyle = {
    padding: '8px',
    border: '1px solid #e0e0e0',
    textAlign: 'center',
    fontWeight: 'bold',
    color: '#333',
    background: '#f0f4ff',
    whiteSpace: 'nowrap',
};

const schedulerPrintTdStyle = {
    padding: '7px 8px',
    border: '1px solid #e0e0e0',
    textAlign: 'center',
    color: '#444',
    fontSize: '11px',
};

export default ShiftScheduler;
